import * as React from "react";
import { Stepper, Step, StepLabel, useMediaQuery } from "@mui/material";
import { styled, useTheme } from "@mui/material/styles";
import StepConnector, {
  stepConnectorClasses,
} from "@mui/material/StepConnector";
import Check from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";

const ORANGE_FORTIO = "#FF3100";
const COR_TEXTO = "#012443";
const COR_INATIVA = "#E0E0E0";

const CustomConnector = styled(StepConnector)(() => ({
  [`&.${stepConnectorClasses.vertical}`]: {
    display: "none",
  },
  [`&.${stepConnectorClasses.horizontal}`]: {
    top: 20,
    left: "calc(-50% + 20px)",
    right: "calc(50% + 20px)",
  },
  [`& .${stepConnectorClasses.line}`]: {
    height: 8,
    border: 0,
    backgroundColor: COR_TEXTO,
    borderRadius: 4,
  },
  [`&.${stepConnectorClasses.active} .${stepConnectorClasses.line}`]: {
    backgroundColor: COR_TEXTO,
  },
  [`&.${stepConnectorClasses.completed} .${stepConnectorClasses.line}`]: {
    backgroundColor: COR_TEXTO,
  },
}));

const CustomStepIconRoot = styled("div")(({ ownerState }) => ({
  backgroundColor: COR_INATIVA,
  zIndex: 1,
  color: COR_TEXTO,
  width: 40,
  height: 40,
  display: "flex",
  borderRadius: "50%",
  justifyContent: "center",
  alignItems: "center",
  fontSize: "1.1rem",
  fontWeight: "bold",
  boxShadow: "0 4px 10px 0 rgba(0,0,0,.25)",
  ...(ownerState.active && {
    backgroundColor: ORANGE_FORTIO,
    color: "#fff",
    boxShadow: "0 4px 10px 0 rgba(0,0,0,.25)",
  }),
  ...(ownerState.completed && {
    backgroundColor: ORANGE_FORTIO,
    color: "#fff",
  }),
  ...(ownerState.canceled && {
    backgroundColor: "#fff",
    border: `3px solid ${ORANGE_FORTIO}`,
    color: ORANGE_FORTIO,
  }),
}));

function CustomStepIcon(props) {
  const { active, canceled, className, completed, icon } = props;

  return (
    <CustomStepIconRoot
      ownerState={{ active, canceled, completed }}
      className={className}
    >
      {canceled ? (
        <CloseIcon sx={{ fontSize: "1.6rem" }} />
      ) : completed ? (
        <Check sx={{ fontSize: "1.5rem" }} />
      ) : (
        <span>{icon}</span>
      )}
    </CustomStepIconRoot>
  );
}

const steps = [
  "P. Validação",
  "Pendente de contratação",
  "Em Analise de perfil",
  "Em Analise do motorista",
  "Contratado",
  "Em Trânsito",
  "Entregue",
  "Finalizado",
];

export default function ModernStepper({ propsStatus, canceled = false }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const parseStep = (value) => {
    if (value === null || value === undefined || value === "") return 0;

    const parsed = Number(value);
    if (Number.isNaN(parsed)) return 0;

    return Math.max(0, Math.min(parsed, steps.length - 1));
  };

  const activeStep = parseStep(propsStatus);

  return (
    <Stepper
      activeStep={activeStep}
      orientation={isMobile ? "vertical" : "horizontal"}
      alternativeLabel={!isMobile}
      connector={<CustomConnector />}
      sx={{
        ...(isMobile && {
          "& .MuiStep-root": {
            marginBottom: "16px",
          },
        }),
        "& .MuiStepLabel-label": {
          color: COR_TEXTO,
          fontWeight: 500,
          marginTop: "8px",
          "&.Mui-active": {
            color: COR_TEXTO,
            fontWeight: 700,
          },
          "&.Mui-completed": {
            color: COR_TEXTO,
            fontWeight: 500,
          },
        },
      }}
    >
      {steps.map((label, index) => (
        <Step key={label}>
          <StepLabel
            StepIconComponent={(stepIconProps) => (
              <CustomStepIcon
                {...stepIconProps}
                canceled={canceled && index === activeStep}
              />
            )}
          >
            {label}
          </StepLabel>
        </Step>
      ))}
    </Stepper>
  );
}
